import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex-center" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { marked } from 'marked'
import { ERROR_CODES } from '../model/ErrorCodes'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import { jslog } from '@gd/jslog'


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorView',
  props: {
    code: {},
    zoneId: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const { t } = useI18n()

const errorCodeAsString = computed(() => {
  return ERROR_CODES[parseInt(props.code)] || props.code
})

/**
 * provide error text with default
 */
const errorText = computed(() => {
  const text = t('errorView.codes.' + errorCodeAsString.value) as string
  // in development it will contain the key if no text has been found - live it's empty
  if (/errorView/.test(text) || !text) {
    return marked(t('errorView.codes.default'))
  }
  return marked(text)
})

/**
 * TODO: maybe the logic could be improved
 */
function onAction() {
  // reload tournaments
  if (
    props.zoneId &&
    // FORBIDDEN and NOT_FOUND is often the case when the user is not allowed to see the
    // zone ( maybe wrong/invalid/manipulated zone name or a none german user tries to enter the skatmaster zone). To
    // avoid navigations loops we redirect them to the zone selection page
    parseInt(props.code) !== ERROR_CODES.FORBIDDEN &&
    parseInt(props.code) !== ERROR_CODES.NOT_FOUND
  ) {
    location.href = location.pathname + '#/tournaments/' + props.zoneId
    // trigger reload - otherwise the page will not do this because of the anchor
    location.reload()
  } else {
    location.href = location.pathname
  }
  // this.$router.push('/')
}

// const error = this.$store.state.error
// tracks that the ErrorView is shown
jslog.send({ name: 'error-view', data: { code: props.code, zoneId: props.zoneId } })

// handle special logic:
switch (parseInt(props.code)) {
  case ERROR_CODES.UNAUTHORIZED:
    // theoretically we can send the user to the login page:
    // this.$router.replace('/extern/login')
    break
}

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_content = _resolveComponent("t-content")!

  return (_openBlock(), _createBlock(_component_t_content, { main: "" }, {
    default: _withCtx(() => [
      (_ctx.zoneId)
        ? (_openBlock(), _createBlock(CTournamentHeader, {
            key: 0,
            zone: _ctx.zoneId,
            language: "de"
          }, null, 8, ["zone"]))
        : _createCommentVNode("", true),
      _createVNode(_component_t_container, {
        class: "error-view",
        "data-qe-id": `error-view-${_ctx.code}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_t_text, null, {
              default: _withCtx(() => [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('errorView.main.title')), 1),
                _createElementVNode("div", { innerHTML: errorText.value }, null, 8, _hoisted_2),
                _createElementVNode("img", {
                  src: require('@/assets/error/error_asset.png'),
                  alt: "broken cards"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_t_button, { onClick: onAction }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('errorView.main.button')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["data-qe-id"])
    ]),
    _: 1
  }))
}
}

})